/* PDP behaviors — ported 1:1 from pdp-client.tsx (gallery, tabs, accordion,
   running total). Add-to-cart + the quantity stepper mechanics live in cart.js.
   No-ops when the PDP isn't on the page. */
(function () {
  "use strict";

  /* ── Gallery — swap the hero on thumbnail click ─────────────────────── */
  document.querySelectorAll("[data-pdp]").forEach(function (pdp) {
    var main = pdp.querySelector("[data-pdp-main] .td-thumb__img");
    var thumbs = pdp.querySelectorAll("[data-pdp-thumb]");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var src = btn.getAttribute("data-src");
        if (src) { main.removeAttribute("srcset"); main.src = src; }
        thumbs.forEach(function (b) {
          b.setAttribute("aria-pressed", b === btn ? "true" : "false");
        });
      });
    });
  });

  /* ── Running total — reflects the quantity stepper ──────────────────── */
  document.querySelectorAll("[data-pdp]").forEach(function (pdp) {
    var unit = parseInt(pdp.getAttribute("data-unit"), 10) || 0; // cents
    var stepper = pdp.querySelector("[data-qty]");
    function totals() {
      // desktop total is inside [data-pdp]; the mobile sticky total sits outside it
      var els = document.querySelectorAll("[data-pdp-total]");
      var qty = stepper ? (parseInt(stepper.querySelector("[data-qty-val]").textContent, 10) || 1) : 1;
      var money = "$" + ((unit * qty) / 100).toFixed(2);
      els.forEach(function (el) { el.textContent = money; });
    }
    if (stepper) {
      stepper.addEventListener("qty:change", totals);
    }
  });

  /* ── Tabs — click + roving arrow keys (matches <Tabs>) ──────────────── */
  document.querySelectorAll("[data-pdp-tabs]").forEach(function (wrap) {
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll("[data-tab]"));
    var panels = wrap.querySelectorAll("[data-tab-panel]");
    if (!tabs.length) return;
    function activate(name, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute("data-tab") === name;
        t.classList.toggle("td-tabs__tab--active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (pn) { pn.hidden = pn.getAttribute("data-tab-panel") !== name; });
    }
    tabs.forEach(function (t) {
      t.addEventListener("click", function () { activate(t.getAttribute("data-tab")); });
    });
    wrap.querySelector(".td-tabs").addEventListener("keydown", function (e) {
      if (["ArrowLeft", "ArrowRight", "Home", "End"].indexOf(e.key) === -1) return;
      e.preventDefault();
      var idx = tabs.findIndex(function (t) { return t.getAttribute("aria-selected") === "true"; });
      var next = idx;
      if (e.key === "ArrowLeft") next = (idx - 1 + tabs.length) % tabs.length;
      if (e.key === "ArrowRight") next = (idx + 1) % tabs.length;
      if (e.key === "Home") next = 0;
      if (e.key === "End") next = tabs.length - 1;
      activate(tabs[next].getAttribute("data-tab"), true);
    });
  });

  /* ── Accordion — single open, matches <Accordion> ───────────────────── */
  document.querySelectorAll("[data-accordion]").forEach(function (acc) {
    var items = Array.prototype.slice.call(acc.querySelectorAll(".td-accordion__item"));
    items.forEach(function (item) {
      var q = item.querySelector("[data-acc-q]");
      if (!q) return;
      q.addEventListener("click", function () {
        var isOpen = item.classList.contains("td-accordion__item--open");
        items.forEach(function (it) {
          it.classList.remove("td-accordion__item--open");
          var b = it.querySelector("[data-acc-q]");
          if (b) b.setAttribute("aria-expanded", "false");
        });
        if (!isOpen) { item.classList.add("td-accordion__item--open"); q.setAttribute("aria-expanded", "true"); }
      });
    });
  });
})();
